import { TFunc } from '@Translations/types';

// Maps legacy grade values (as returned by the backend) to their new display
// names. Serves both the Deterioration Model GRADE options (lowercase codes,
// e.g. 'extreme') and the Risk RISK_GRADE options (grade names, e.g. 'Extreme').
// Display-only: the underlying value is unchanged.
// Each branch uses a literal-string label so i18next-parser can extract the new keys.
export const getDeteriorationGradeLabel = (value: string, t: TFunc): string => {
	switch (value.toLowerCase()) {
		case 'extreme':
			return t('Critical');
		case 'high':
			return t('Concerning');
		case 'medium':
			return t('Moderate');
		case 'low':
			return t('Stable');
		case 'negligible':
			return t('Optimal');
		default:
			return value;
	}
};
